"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_2 = require("react");
const react_flow_renderer_1 = __importStar(require("react-flow-renderer"));
require("react-flow-renderer/dist/style.css");
const CustomNode_1 = __importDefault(require("./customNode/CustomNode"));
const team_management_pathway_svg_1 = __importDefault(require("../../assets/images/pathways/team-management-pathway.svg"));
const business_leadership_pathway_svg_1 = __importDefault(require("../../assets/images/pathways/business-leadership-pathway.svg"));
const management_accelerator_pathway_svg_1 = __importDefault(require("../../assets/images/pathways/management-accelerator-pathway.svg"));
const CircleDotNode_1 = __importDefault(require("./circleDotNode/CircleDotNode"));
const initialNodes = [
    {
        id: "1",
        type: "textUpdater",
        data: { title: "Team Management", imgSrc: team_management_pathway_svg_1.default },
        position: { x: 0, y: 0 },
        sourcePosition: react_flow_renderer_1.Position.Right,
        targetPosition: undefined,
    },
    {
        id: "4",
        type: "textUpdater",
        data: { title: "Business Leadership", imgSrc: business_leadership_pathway_svg_1.default },
        position: { x: 0, y: 300 },
        sourcePosition: react_flow_renderer_1.Position.Right,
        targetPosition: undefined,
    },
    {
        id: "2",
        type: "textUpdater",
        data: {
            title: "Management Accelerator",
            imgSrc: management_accelerator_pathway_svg_1.default,
        },
        position: { x: 500, y: 0 },
        targetPosition: react_flow_renderer_1.Position.Left,
        sourcePosition: undefined,
    },
    {
        id: "3",
        type: "circleDotNode",
        data: {},
        position: { x: 370, y: 125 },
    },
];
const initialEdges = [
    { id: "e1-3", source: "1", target: "3", type: "step" },
    {
        id: "e4-3",
        source: "4",
        target: "3",
        type: "step",
        targetHandle: "bottom-handle",
    },
    { id: "e3-2", source: "3", target: "2", type: "step" },
];
const defaultEdgeOptions = {
    animated: true,
};
const nodeTypes = {
    textUpdater: CustomNode_1.default,
    circleDotNode: CircleDotNode_1.default,
};
function SamplePathwayFlow() {
    const [nodes, setNodes] = (0, react_2.useState)(initialNodes);
    const [edges, setEdges] = (0, react_2.useState)(initialEdges);
    const onNodesChange = (0, react_2.useCallback)((changes) => setNodes((nds) => (0, react_flow_renderer_1.applyNodeChanges)(changes, nds)), [setNodes]);
    const onEdgesChange = (0, react_2.useCallback)((changes) => setEdges((eds) => (0, react_flow_renderer_1.applyEdgeChanges)(changes, eds)), [setEdges]);
    const onConnect = (0, react_2.useCallback)((connection) => setEdges((eds) => (0, react_flow_renderer_1.addEdge)(connection, eds)), [setEdges]);
    return (react_1.default.createElement(react_flow_renderer_1.default, { nodes: nodes, style: {
            height: "500px",
            borderRadius: "8px",
            background: "#F7F7F7",
            maxWidth: "1180px",
            marginTop: "25px",
        }, nodeTypes: nodeTypes, edges: edges, onNodesChange: onNodesChange, onEdgesChange: onEdgesChange, onConnect: onConnect, fitView: true, defaultEdgeOptions: defaultEdgeOptions }));
}
exports.default = SamplePathwayFlow;
